import './styles.scss';

export const ShopSite = ({ inputs}) => (
  <div className="shop-website">
    <p className="shop-website__title">Shop</p>
    <div className="shop-website__url">
      {inputs}
    </div>
  </div>
)